var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalloon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.333 512c-5.891 0-10.667-4.776-10.667-10.667a50.41 50.41 0 0111.392-28.757A42.066 42.066 0 00255.999 448c0-7.808-9.771-14.933-19.2-21.973-11.541-8.533-23.467-17.301-23.467-31.36a50.088 50.088 0 0114.379-31.701c3.093-3.84 6.955-8.533 6.955-10.965 0-5.891 4.776-10.667 10.667-10.667S256 346.11 256 352.001a39.977 39.977 0 01-11.691 24.363 32.491 32.491 0 00-9.643 18.304c0 3.285 8.896 9.856 14.763 14.187 12.437 9.173 27.904 20.565 27.904 39.147a62.039 62.039 0 01-13.611 36.544 32.002 32.002 0 00-7.723 16.789C256 507.224 251.224 512 245.333 512z",
    fill: "#fdf6e3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M295.552 344.448l-32-32c-4.165-4.164-10.917-4.164-15.083 0l-32 32A10.668 10.668 0 00224 362.667h64a10.667 10.667 0 007.552-18.219z",
    fill: "#fdf6e3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256 0c-82.436.094-149.239 66.898-149.333 149.333 0 84.075 90.368 181.333 149.333 181.333s149.333-97.259 149.333-181.333C405.239 66.898 338.436.094 256 0z",
    fill: "#fdf6e3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160 160c-5.891 0-10.667-4.776-10.667-10.667C149.404 90.452 197.119 42.737 256 42.667c5.891 0 10.667 4.776 10.667 10.667S261.891 64 256 64c-47.128 0-85.333 38.205-85.333 85.333 0 5.891-4.776 10.667-10.667 10.667z",
    fill: "#fdf6e3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloon2);
export default __webpack_public_path__ + "static/media/balloon2.4c962dbc.svg";
export { ForwardRef as ReactComponent };